import React from 'react'
import { useMutation } from 'react-apollo'
import { useLocation } from 'react-router-dom'
import useServerError from '../../../src/hooks/useServerError'
import { Form, FormIdentifier } from '../forms/FieldFactory'
import FormBuilder from '../forms/FormBuilder'
import ResendInvitationMutation from '../../graphql/ResendInvitationMutation.gql'
import { Helmet } from 'react-helmet'
import {
  BasicType,
  ElementType,
} from '../../../src/components/forms/FormElementParts'

const form: Form = {
  fields: [
    {
      icon: 'Email',
      label: 'Email',
      name: 'email',
      type: ElementType.EMAIL,
    },
    {
      label: 'Send Instructions',
      type: BasicType.SUBMIT,
    },

    {
      label: "Already have an account? <a href='/sign_in'>Sign In</a>",
      type: BasicType.FOOTER,
    },
  ],
  header: 'Resend Your Invitation',
  type: FormIdentifier.RESEND_INVITATION,
}

const ResendInvitationPage = () => {
  const [resendInvitation, { data }] = useMutation(ResendInvitationMutation)
  const { clearServerError, serverError, setServerError } = useServerError()
  const location = useLocation()
  const handleSubmit = React.useCallback(
    (formData: FormData) => {
      resendInvitation({ variables: formData })
    },
    [resendInvitation],
  )
  React.useEffect(() => {
    const message =
      data?.resendInvitation?.message || (location?.state as any)?.message
    if (message) {
      setServerError({
        message,
        errors: {},
      })
    }
  }, [data, location, setServerError])

  return (
    <React.Fragment>
      <Helmet
        title={`${
          (window as any).CMD.config.tenant.page_title
        } - Resend Your Invitation`}
      />
      <FormBuilder
        form={form}
        onChange={clearServerError}
        onSubmit={handleSubmit}
        serverError={serverError}
      />
    </React.Fragment>
  )
}

export default ResendInvitationPage
